<script>
import { Line, mixins } from "vue-chartjs";

export default {
    extends: [Line],
    mixins: [Line, mixins.reactiveData],
    //====================================================================
    props: {
        //chartOptions: {},
        chartDataChild: {},
        yRange: { min: Number, max: Number },
    },
    //====================================================================
    data() {
        return {
            //ymax: "15",
        };
    },
    //====================================================================
    created: function () {
        //this.buildOption();
    },
    //====================================================================
    mounted() {
        //this.renderChart(this.chartDataChild, this.chartOptions);
    },
    //====================================================================
    watch: {
        chartDataChild: async function () {
            await this.buildOption();
            await this.renderChart(this.chartDataChild, this.chartOptions);
        },
    },
    //====================================================================
    methods: {
        buildOption() {
            this.chartOptions = {
                maintainAspectRatio: false,
                legend: { display: true, position: "bottom" },
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            distribution: "linear", // use 'linear'(default) or 'series'
                            time: { displayFormats: { hour: "D日H時", day: "D日H時", month: "D日H時" } },
                            ticks: { minRotation: 0, maxRotation: 0, maxTicksLimit: 4 },
                            gridLines: { drawOnChartArea: true },
                        },
                    ],
                    yAxes: [
                        {
                            id: "axis-turbidity",
                            display: true,
                            position: "left",
                            scaleLabel: { display: false, labelString: "濁度(FTU)ホルマジン基準", fontColor: "black" },
                            ticks: {
                                fontColor: "brown",
                                min: Number(this.yRange.min) ? Number(this.yRange.min) : 0,
                                max: Number(this.yRange.max) ? Number(this.yRange.max) : undefined,
                            },
                        },
                        {
                            display: false,
                            id: "axis-day-night",
                            ticks: { min: 0, max: 100 },
                        },
                    ],
                },
                tooltips: {
                    enabled: true,
                },
                elements: {
                    line: { tension: 0.2 }, // line: { tension: 0.4 },
                    point: { radius: 1, hitRadius: 10, hoverRadius: 1, hoverBorderWidth: 3 },
                },
                animation: false,
            };
        },
    },
    //====================================================================
};
</script>
